<template>
  <div>
    <page-title :title="title"></page-title>
    <construction></construction>
  </div>
</template>

<script>
  import Construction from '@/components/Construction'
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'about',
    data () {
      return {
        title: 'About me'
      }
    },
    components: {
      Construction,
      PageTitle
    }
  }
</script>

<styles>

</styles>



// WEBPACK FOOTER //
// About.vue?a1aeeb86